var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "24px",
    viewBox: "0 0 20.0 24.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "contacts_i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420,0 L420,1738 L0,1738 L0,0 L420,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "contacts_i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,22 L18,24 L2,24 L2,22 L18,22 Z M18,4 C19.1,4 20,4.9 20,6 L20,18 C20,19.1 19.1,20 18,20 L2,20 C0.9,20 0,19.1 0,18 L0,6 C0,4.9 0.9,4 2,4 Z M10,13 C8.33,13 5,13.83 5,15.5 L5,17 L15,17 L15,15.5 C15,13.83 11.67,13 10,13 Z M10,6.75 C8.76,6.75 7.75,7.76 7.75,9 C7.75,10.24 8.76,11.25 10,11.25 C11.24,11.25 12.25,10.24 12.25,9 C12.25,7.76 11.24,6.75 10,6.75 Z M18,0 L18,2 L2,2 L2,0 L18,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30.0 -148.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#contacts_i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.999999999998636 148.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.0 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#contacts_i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 20,0 20,24 0,24 0,0",
    stroke: "none",
    fill: "currentColor"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.0dc4eebdd186a61cbdf61cdab6da6152.svg";
export { ForwardRef as ReactComponent };